import styled from 'styled-components';
import { color } from 'styles/colors';

export const containerSwitch: any = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  width: 32px;

  padding: 15px;
  cursor: pointer;
`;

interface LabelFatherProps {
  isChecked: boolean;
}

export const labelFather: any = styled.label<LabelFatherProps>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 16px;
  border-radius: 20px;
  background-color: ${color.interface.darkgray4};
  transform: translateY(50%);
  transition: all ease 0.5s;
  cursor: pointer;
  input {
    display: none;
  }

  span {
    position: absolute;
    display: flex;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid ${color.interface.white};
    transform: ${props =>
      props.isChecked ? 'translate(-30%, 29%)' : 'translate(30%, 29%)'};
    background-color: ${color.interface.white};
    cursor: pointer;
  }
`;
